import { PersonBase } from './PersonBase';

/** Represents an artist who designed a graphic for a particular product. */
export class Artist extends PersonBase {

	constructor(init?: Partial<Artist>) {
		super();
		Object.assign(this, init);
	}

}
